import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    key: String
  }

  connect() {
    if (!this.hasKeyValue || !this.keyValue) return

    window.sessionSharedKeyRawB64 = this.keyValue
    window.sessionSharedKey = this.keyValue
    window.dispatchEvent(new CustomEvent("sessionKeyReady"))
  }

  disconnect() {
    if (window.sessionSharedKey === this.keyValue) {
      window.sessionSharedKey = null
    }

    if (window.sessionSharedKeyRawB64 === this.keyValue) {
      window.sessionSharedKeyRawB64 = null
    }
  }
}
